import _findIndex from 'lodash/findIndex'

export const updateOrAddItemsById = ({ currentItems, receivedItems }) => {
    const items = Object.assign([], currentItems)

    if (Array.isArray(receivedItems)) {
        receivedItems.forEach((item) => {
            const key = _findIndex(items, ['id', item.id])

            if (key > -1 && items[key]) {
                items[key] = item
            } else {
                items.push(item)
            }
        })
    }

    return items
}

export const updateOrAddItemById = (array, element) => {
    const { id } = element
    const index = array.findIndex((item) => item.id === id)

    if (index === -1) {
        return [...array, element]
    }

    const item = { ...array[index], ...element }

    return [...array.slice(0, index), item, ...array.slice(index + 1)]
}

export const removeItemsById = ({ currentItems, id, idKey = 'id' }) => {
    const items = Object.assign([], currentItems)

    if (id) {
        const index = items.findIndex((o) => o[idKey] === id)

        if (index > -1 && items[index]) {
            items.splice(index, 1)
        }
    }

    return items
}

export const noact = () => () => Promise.resolve()

export const syncSlice = (value, update) => {
    if (Array.isArray(value)) return updateOrAddItemById(value, update)
    return { ...value, ...update }
}
